import React, { useEffect } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import LoginPageWrapper from '../Components/LoginPageWrapper';
import LoginFormHeader from '../Components/LoginFormHeader';

import './Organization.scss';
import { LinkElement } from '@els/els-react--link-element';
import { ButtonWithIcon } from '@els/els-react--button';

const spinnerId = 'organizationForm';

function Organization(props) {
  const { isLoading, response, login, goToLoginPage } = props;

  useEffect(() => {
    if (!response) {
      goToLoginPage();
    }
    // eslint-disable-next-line
  }, []);

  const availablePaths = get(response, 'data.availablePaths', []);

  return (
    <LoginPageWrapper className="react-page-organization-page">
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <LoginFormHeader
        actionMessage="Welcome to Reaxys Choice Screen"
        infoMessage="To log in please select one of the departments below."
      />
      <div className="organization-page-form-wrapper u-els-padding-2x u-els-padding-top u-els-padding-bottom u-els-margin-top-1o4 u-els-background-color-background">
        <ul className="u-els-font-size-body-large u-els-line-height-default">
          {availablePaths.map((data) => (
            <li key={data.label} className="u-els-margin-bottom-1o2">
              <ButtonWithIcon
                type="link"
                sprite="ChevronRight"
                className="e2e-select-organization"
                tabIndex="0"
                onClick={(e) => {
                  e.preventDefault();
                  login(data.id);
                }}>
                {data.label}
              </ButtonWithIcon>
            </li>
          ))}
        </ul>
      </div>
    </LoginPageWrapper>
  );
}

Organization.propTypes = {
  isLoading: PropTypes.bool,
  response: PropTypes.object,
  login: PropTypes.func.isRequired,
  goToLoginPage: PropTypes.func.isRequired,
};

export default Organization;
